import {ServiceBase} from '../ServiceBase';
import {IOverlayService} from './overlay.service.interface';
import {action, computed, observable} from 'mobx';
import {IServiceFactoryExtended} from '../service-factory-extended.interface';
import {ORBIT_OVERLAY_OPEN} from '../../themes/css-global-classes';
import {STANDARD_TOPIC_HEADER} from '../casinofied/message-broker/message-broker.consts';


export class OverlayService extends ServiceBase implements IOverlayService {

  constructor(services: IServiceFactoryExtended) {
      super(services);
      this.services.sdk.events.onLoginFormOpen(() => this.services.dom.body.classList.add(ORBIT_OVERLAY_OPEN));
      this.services.sdk.events.onLoginFormClosed(() => this.services.dom.body.classList.remove(ORBIT_OVERLAY_OPEN));
  }

  @observable
  zIndex?: number;

  @computed get isOpen(): boolean {
    return this._openInstances > 0;
  }

  @observable.ref private _openInstances: number = 0;

  @action.bound
  openOverlay(zIndex?: number): void {
    if (!this.isOpen) {
      this.services.dom.body.classList.add(ORBIT_OVERLAY_OPEN);
    }
    if (zIndex) {
      this.zIndex = zIndex;
    }
    this._openInstances++;
  }

  @action.bound
  closeOverlay(): void {

    if(!this.isOpen) {
      return;
    }

    if (this._openInstances > 0) {
      this._openInstances--;
    }

    if (!this.isOpen) {
      this.services.dom.body.classList.remove(ORBIT_OVERLAY_OPEN);
      this.zIndex = undefined;
      this.services.messageBroker.channels.navigation.topics.overlayClicked.publish(STANDARD_TOPIC_HEADER, {});
    }
  }
}
